import { render, staticRenderFns } from "./QueryOrder.vue?vue&type=template&id=64e6022e&scoped=true&"
import script from "./QueryOrder.vue?vue&type=script&lang=js&"
export * from "./QueryOrder.vue?vue&type=script&lang=js&"
import style0 from "./QueryOrder.vue?vue&type=style&index=0&id=64e6022e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6022e",
  null
  
)

export default component.exports